import { render, staticRenderFns } from "./PcPreview.vue?vue&type=template&id=eeb87232"
import script from "./PcPreview.vue?vue&type=script&lang=ts"
export * from "./PcPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports